export default "__VITE_ASSET__D$azHCq___"